module.exports = __webpack_public_path__ + "img/discovery.fa1768ca.png";